<template>
  <div class="Orders">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-card class="box-card" v-loading="loading">
          <div class="flex-space-between flex-wrap label-md-bold-black stock-ranking capitalize">
            <div class="flex bottom-margin-10">
              <img src="../assets/images/rank0.png" style="height: 18px; margin-right: 10px" />
              Orders
              <span v-if="getOpenOrders.length">({{ getOpenOrders.length }})</span>
            </div>

            <div class="flex-end">
              <input v-model="search_open_order" size="mini" placeholder="Search" style="width: 180px; height: 27px; font-size: 16px; border: 1px solid #C0C4CC; border-radius: 4px; padding: 0 15px;"></input>
              <div class="relative">
                <i class="el-icon-search" style="position: absolute; bottom: -8px; right: 8px; color: #C0C4CC;"></i>
              </div>
            </div>
          </div>

          <table class="holdings-description-table top-margin-15">
            <thead>
              <tr>
                <th style="text-align: left">Symbol</th>
                <th>Qty</th>
                <th>Price</th>
                <th v-if="userProfile && userProfile.utm_source != 'Paytm Money' && userProfile.utm_source != 'Basan'">Time</th>
                <th>Type</th>
                <th v-if="userProfile && userProfile.utm_source != 'Paytm Money' && userProfile.utm_source != 'Choice'">Product</th>
                <!-- <th>LTP</th> -->
                <th>Status</th>
                <!-- <th v-if="userProfile.utm_source != 'Rmoney' && userProfile.utm_source != 'Maitra Commodities'">
                  Action
                </th> -->
                <!-- <el-checkbox v-model="check_open_orders" @change="checkAllOpenOrders()"></el-checkbox> -->
                <!-- <th>&nbsp;</th> -->
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, item_index) in getOpenOrders.filter((data) => !search_open_order || data.symbol.toLowerCase().includes(search_open_order.toLowerCase()))" :key="item_index">
                <td style="text-align: left">{{ item.symbol }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.price }}</td>
                <td v-if="userProfile && userProfile.utm_source != 'Paytm Money' && userProfile.utm_source != 'Basan'">
                  {{ item.timestamp ? item.timestamp : item.created }}
                </td>

                <td>
                  <div class="tag" :style="[item.transaction_type == 'BUY' || item.transaction_type == 'B' ? { background: '#079e3e' } : item.transaction_type == 'SELL' || item.transaction_type == 'S' ? { background: '#d64040' } : {}]">
                    {{ item.transaction_type == 'SELL' || item.transaction_type == 'S' ? 'SELL' : item.transaction_type == 'BUY' || item.transaction_type == 'B' ? 'BUY' : item.transaction_type }}
                  </div>
                </td>

                <td v-if="userProfile && userProfile.utm_source != 'Paytm Money' && userProfile.utm_source != 'Choice'">
                  {{ item.product == 'CNC' || item.product == 'C' || item.product == 'D' ? 'Delivery' : item.product == 'MIS' || item.product == 'I' ? 'Intraday' : item.product == 'MIS' || item.product == 'M' ? 'Carry Forward' : item.product == 'MIS' || item.product == 'V' ? 'Cover Order' : item.product == 'NRML' ? 'Normal' : item.product == 'B' ? 'Bracket Order' : item.product }}
                </td>

                <!-- <td>{{ item.ltp }}</td> -->

                <td style="text-transform: uppercase" :style="[item.status == 'TRADED' ? { color: '#079e3e' } : item.status == 'REJECTED' || item.status == 'CANCELLED' ? { color: '#d64040' } : {}]">
                  {{ item.status }}
                  <el-popover v-if="item.message" placement="top" title="Message" width="250" trigger="hover" :content="item.message">
                    <i slot="reference" class="el-icon-info cursor-pointer font-1rem" style="color: #d60918"></i>
                  </el-popover>
                </td>
              </tr>
            </tbody>
          </table>

          <NoDataFound v-if="!getOpenOrders.length" style="padding: 0"></NoDataFound>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';
import NoDataFound from '@/components/NoDataFound.vue';
import CripNotice from 'crip-vue-notice';

export default {
  name: 'Orders',

  components: {
    NoDataFound,
  },

  data() {
    return {
      search_open_order: '',
      search_executed_order: '',
      search_trade_history: '',
      check_open_orders: false,
      loading: false,
      open_orders: [
        // {
        //     checked: false,
        //     time: '11:30:45',
        //     type: 'BUY',
        //     instrument: 'HDFCBANK',
        //     product: 'CNC',
        //     qty: '0/1',
        //     ltp: 1384.25,
        //     price: 1237.00,
        //     status: 'OPEN'
        // }
      ],
      executed_orders: [
        // {
        //     time: '11:30:45',
        //     type: 'SELL',
        //     instrument: 'HDFCBANK',
        //     product: 'CNC',
        //     qty: '1/1',
        //     avg_price: 1383.50,
        //     status: 'COMPLETE'
        // }
      ],
      trades: [
        // {
        //     id: 27961292,
        //     time: '11:51:19',
        //     type: 'BUY',
        //     instrument: 'HDFCBANK',
        //     product: 'CNC',
        //     qty: '1/1',
        //     avg_price: 1383.50
        // }
      ],
    };
  },

  mounted() {
    if (localStorage.getItem('selected_broker')) {
      this.getOrders();
    }
  },

  methods: {
    modifyOrder(order) {
      // commited selected order id and set active sub menu to trade
      this.$store.commit('commitOrderId', order.id);
      this.$store.commit('commitTradeMenu', 'TRADE');
      this.$store.commit('commitSelectedOrder', order);
    },

    cancelOrder(stock) {
      this.loading = true; //displayed loader

      var obj = {
        broker_id: localStorage.getItem('selected_broker') ? Number(localStorage.getItem('selected_broker')) : '',
        order_id: stock.id,
      };

      // if user is from paytm money
      if (localStorage.getItem('selected_broker') == 10) {
        obj.group_id = stock.group_id;
        obj.serial_no = stock.serial_no;
        obj.security_id = stock.security_id;
        obj.transaction_type = stock.transaction_type == 'B' ? 'BUY' : 'SELL';
        obj.exchange = stock.exchange;
        obj.segment = stock.segment;
        obj.product_type = stock.product;
        obj.quantity = stock.quantity;
        obj.validity = stock.duration;
        obj.order_type = stock.order_type_str == 'Limit' ? 'LIMIT' : 'MARKET';
        obj.price = stock.price;
      }

      // if user is from choice
      if (localStorage.getItem('selected_broker') == 16) {
        obj.exchange_order_no = stock.exchange_order_no;
        obj.gateway_order_no = stock.gateway_order_no;
        obj.exchange_order_time = stock.exchange_order_time;
        obj.stock_id = stock.stock_id;
        obj.transaction_type = stock.transaction_type;
        obj.exchange = stock.exchange;
        obj.order_type = stock.order_type;
        obj.price = stock.price;
        obj.quantity = stock.quantity;
        obj.disclosed_quantity = stock.disclosed_quantity;
        obj.validity = stock.duration;
        obj.product_type = stock.product;
      }

      // if user is from Nirman or Tradeplus
      if (localStorage.getItem('selected_broker') == 15 || localStorage.getItem('selected_broker') == 17) {
        obj.exchange = stock.exchange;
        obj.stock_id = stock.stock_id;
      }

      serverAddr
        .post('/trade/v1/cancel_order', obj)
        .then((response) => {
          if (response.data.status) {
            new CripNotice({
              title: 'Success',
              description: response.data.validation,
              type: 'success',
              duration: 3,
            });
            this.getOrders();
          } else {
            this.loading = false; //hide loader
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false; //hide loader
        });
    },

    checkAllOpenOrders() {
      if (this.check_open_orders) {
        this.open_orders.forEach((e) => {
          e.checked = true;
        });
      } else {
        this.open_orders.forEach((e) => {
          e.checked = false;
        });
      }
    },

    getOrders() {
      this.loading = true; //displayed loader

      serverAddr
        .post('/trade/v1/detail_order', {
          broker_id: localStorage.getItem('selected_broker') ? Number(localStorage.getItem('selected_broker')) : '',
          page_segment: 'equity',
        })
        .then((response) => {
          if (response.data.status) {
            this.open_orders = response.data.data;
          } else {
            this.open_orders = [];
          }

          this.loading = false; //hide loader
        })
        .catch((error) => {
          console.log(error);
          this.loading = false; //hide loader
          this.open_orders = [];
        });
    },
  },

  computed: {
    getOpenOrders() {
      return this.open_orders;
    },

    getExecutedOrders() {
      return this.executed_orders;
    },

    getTradeList() {
      return this.trades;
    },

    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },
  },
};
</script>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.Orders {
  .box-card {
    box-shadow: none;
    border-radius: 10px;
  }

  .tag {
    padding: 2px;
    border-radius: 4px;
    opacity: 1;
    color: #fff;
    width: 70px;
    margin: 0 auto;
  }

  @media screen and (max-width: 800px) {
    .holdings-description-table {
      display: block;
    }
  }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.Orders .el-popper {
  word-break: break-word;
}
</style>
